module.exports = __webpack_public_path__ + "1c99bbe675587f8f04fc04fc2624c230.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio1/03_1MCA Mutoflor.mp3
// module id = 772
// module chunks = 0